module.exports = __webpack_public_path__ + "img/9.aff2f41b.webp";